import {vMap} from "./vectorMap/vectorMap";

window.vMap = vMap